var React = require('react');

function CollapseRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.056 25.5l-6.074 6.073a1.49 1.49 0 00.008 2.114 1.498 1.498 0 002.12 0l8.627-8.626c.142-.142.248-.304.326-.495.003-.004.003-.007.003-.01 0-.005 0-.008.004-.012.07-.17.106-.346.106-.544a1.29 1.29 0 00-.106-.544c-.004-.004-.004-.008-.004-.011 0-.004 0-.007-.003-.01a1.472 1.472 0 00-.326-.496l-8.633-8.633a1.505 1.505 0 00-2.122 0 1.498 1.498 0 000 2.12l6.075 6.075H4.311A1.49 1.49 0 002.812 24a1.49 1.49 0 001.5 1.5h23.744zm17.131-24a1.5 1.5 0 00-3 0v45a1.5 1.5 0 003 0v-45z"}));
}

CollapseRight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = CollapseRight;

CollapseRight.default = CollapseRight;
